(() => {
  if (window.__msR14Reveal) return;
  window.__msR14Reveal = true;

  // Elements are only hidden once this script has confirmed it can bring them
  // back. If it never runs, .ms-reveal-ready is never set and every target
  // renders normally -- the failure mode is "no animation", never "no content".
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');

  const run = (scope = document) => {
    const items = [...scope.querySelectorAll('[data-ms-reveal]')]
      .filter((el) => !el.dataset.msRevealBound);
    if (!items.length) return;

    items.forEach((el) => {
      el.dataset.msRevealBound = '1';
      el.classList.add('ms-reveal');
    });
    document.documentElement.classList.add('ms-reveal-ready');

    if (reduce.matches || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-revealed'));
      return;
    }

    let observerRan = false;

    const io = new IntersectionObserver((entries, obs) => {
      observerRan = true;
      entries.filter((e) => e.isIntersecting).forEach((entry, i) => {
        const el = entry.target;
        setTimeout(() => el.classList.add('is-revealed'), i * 60);
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

    items.forEach((el) => io.observe(el));

    // A hidden document freezes IntersectionObserver as well as the animation
    // timeline, so a page restored from the back/forward cache or opened in a
    // background tab could otherwise stay blank. Reveal everything outstanding
    // as soon as the document becomes visible again.
    const flush = () => {
      if (document.visibilityState !== 'visible') return;
      items.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0) el.classList.add('is-revealed');
      });
    };
    document.addEventListener('visibilitychange', flush);
    addEventListener('pageshow', flush);

    // Last resort, and deliberately an exact test rather than a timeout on the
    // reveal itself. Observing an element queues an initial callback whether or
    // not it intersects, so a callback that has never run means the observer is
    // dead -- not that the reader simply has not scrolled that far yet. Only
    // that case reveals everything; a working observer is left alone, which is
    // what a blanket timeout got wrong (it fired mid-read and skipped the
    // animation for everything below the fold).
    setTimeout(() => {
      if (observerRan) return;
      items.forEach((el) => el.classList.add('is-revealed'));
    }, 2000);
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => run(), { once: true })
    : run();

  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
